module.exports = __webpack_public_path__ + "static/img/login.a128da4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/prism_admin/images/login.jpg
// module id = 5ptS
// module chunks = 2